<script>
import {
    mapGetters
} from 'vuex';
export default {
    name: 'CompetenceCardsFiltersDataProvider',
    computed: mapGetters('competences', {
		competenceCards: 'competenceCards',
		competenceFilterOptions: 'competenceFilterOptions',
		courseFilterOptions: 'courseFilterOptions',
		workplaceFilterOptions: 'workplaceFilterOptions',
		appliedFilters: 'appliedFilters',
		sortDirection: 'sortDirection',
		competenceCards: 'competenceCards',
	}),
	methods: {
		setCompetenceFilter (competence) {
			this.$store.dispatch('competences/setCompetenceFilter', (competence) ? competence : '');
		},
		setCourseFilter (course) {
			this.$store.dispatch('competences/setCourseFilter', (course) ? course : '');
		},
		setWorkplaceFilter (workplace) {
			this.$store.dispatch('competences/setWorkplaceFilter', (workplace) ? workplace : '');
		},
		setNameFilter (name) {
			this.$store.dispatch('competences/setNameFilter', name);
		},
		resetAllFilters() {
			this.$store.dispatch('competences/resetAllFilters');
		},
		setSortDirection (sortDirection) {
			this.$store.dispatch('competences/setSortDirection', {
				sortDirection
			});
		},
		setExpiringFilter(expiring) {
			this.$store.dispatch('competences/setExpiringFilter', expiring);
		}
	},
    render() {
        if (!this.$scopedSlots.default) {
            return;
        }

        const slotScope = {
			competenceCards: this.competenceCards,
			competenceFilterOptions: this.competenceFilterOptions,
			courseFilterOptions: this.courseFilterOptions,
			setCompetenceFilter: this.setCompetenceFilter,
			setCourseFilter: this.setCourseFilter,
			workplaceFilterOptions: this.workplaceFilterOptions,
			setWorkplaceFilter: this.setWorkplaceFilter,
			setNameFilter: this.setNameFilter,
			appliedFilters: this.appliedFilters,
			sortDirection: this.sortDirection,
			resetAllFilters: this.resetAllFilters,
			setSortDirection: this.setSortDirection,
			setExpiringFilter: this.setExpiringFilter,
			anyFiltersApplied: (Object.keys(this.appliedFilters).length > 0)
		};
        return this.$scopedSlots.default(slotScope);
    },
    created() {
	}
}
</script>
